<mat-horizontal-stepper #stepper>
  <mat-step [stepControl]="ldpInput">
    <div fxLayout="row">
      <h4 class="form-page-name">Licensed Design Professional Registration</h4>
    </div>
    <form [formGroup]="ldpInput">
      <div fxLayout="row">
        <div fxFlex="50%">
          <mat-form-field appearance="outline">
            <mat-label>License Type</mat-label>
            <mat-select required id="licensetype" name="licensetype" formControlName="licensetype" required="true">
              <mat-option *ngFor="let item of licenseTypeOptions" [value]="item.value">{{ item.label }}</mat-option>
            </mat-select>
            <mat-error *ngIf="ldpInput.get('licensetype').hasError('required')">
              License Type is required.
            </mat-error>
          </mat-form-field>
        </div>
        <div fxFlex="50%">
          <mat-form-field appearance="outline">
            <mat-label>License Number</mat-label>
            <input required matInput autocomplete="off" placeholder="License Number" id="licensenumber" name="licensenumber" required="true" formControlName="licensenumber" />
            <mat-error *ngIf="ldpInput.get('licensenumber').hasError('required')">
              License Number is required.
            </mat-error>
          </mat-form-field>
        </div>

        <div fxFlex="50%">
            <re-captcha
    *ngIf="recaptchaEnabled"
    #captchaRef
    [siteKey]="siteKey"
    formControlName="recaptchaReactive"
    (resolved)="onCaptchaResolved($event)"
    (expired)="onCaptchaExpired()">
  </re-captcha>
  <br>
          </div>
        <div fxLayout="row">
          <div fxFlex="50%">
            <button mat-button mat-raised-button [disabled]="ldpInput.pristine || ldpInput.invalid" (click)="onlicensecheck(stepper)">
              CONTINUE
            </button>
            <div *ngIf="formAutoSave" style="margin-top: 12px;">
              <mat-progress-bar mode="indeterminate" style="width: 300px;"></mat-progress-bar>
            </div>
            <mat-error *ngIf="ldpshowerror"> {{ ldperrormessage }} </mat-error>
          </div>
        </div>
      </div>
    </form>
  </mat-step>
  <mat-step [stepControl]="ldpinfo">
    <div class="row">
      <h4 class="form-page-name">Licensed Design Professional Registration</h4>
    </div>
    <br>

    <div class="row">
      <div class="col-md-12">
        
        <form [formGroup]="ldpinfo">
          <h4>License Information</h4>
          <div class="row">
            <div class="col-md-6">
              <mat-card style="width: 300px; margin-bottom: 25px;"> <div>
                <div >
                  <strong>Type:</strong>{{ldplicensetype }}
                </div>
               
              </div>
              <div >
                <div >
                  <strong>License Number:</strong> {{ldplicensenumber }}
                </div>
               
              </div>
              <div>
                <div >
                  <strong>License Expires On:</strong>{{ ldplicenseexpdate | date:"MM/dd/yyyy" }}
                </div>
                
              </div>
                   </mat-card>
            
              <h4>Business Details</h4>
              <div class="row">
                <div class="col-md-12">
                  <div>
                    <mat-form-field appearance="outline">
                      <mat-label>Business Name</mat-label>
                      <input type="text" matInput autocomplete="off" placeholder="Business Name" id="bname" name="bname" formControlName="bname"
                             maxlength="100" />
                      <mat-error *ngIf="ldpinfo.get('bname').hasError('required')">
                          Business Name is required.
                      </mat-error>
                  </mat-form-field>
                  </div>
                  <div>
                    <mat-form-field appearance="outline">
                      <mat-label>Business Address</mat-label>
                      <input  type="text" matInput [attr.autocomplete]="false"  placeholder="Business Address" id="address" name="address" formControlName="address"
                             maxlength="100" />
                      <mat-error *ngIf="ldpinfo.get('address').hasError('required')">
                          Business Address is required.
                      </mat-error>
                  </mat-form-field>
                  </div>
    
                  <div>
                    <mat-form-field appearance="outline">
                      <mat-label>Suite #</mat-label>
                      <input  type="text" matInput autocomplete="off" placeholder="Business Address Suite" id="suite" name="suite" formControlName="suite" />
                  </mat-form-field>
                  </div>
        
                  <div>
                    <mat-form-field appearance="outline">
                      <mat-label>City</mat-label>
                      <input  type="text" matInput [attr.autocomplete]="false" placeholder="City" id="city" name="city" formControlName="city" />
                      <mat-error *ngIf="ldpinfo.get('city').hasError('required')">
                          City is required.
                      </mat-error>
                  </mat-form-field>
                  </div>
        
                  <div>
                    <mat-form-field appearance="outline">
                      <mat-label>State</mat-label>
                      <input  type="text" matInput  [attr.autocomplete]="false" placeholder="State" id="state" name="state" formControlName="state"
                             value="CA" />
                  </mat-form-field>
                  </div>
    
                  <div>
                    <mat-form-field appearance="outline">
                      <mat-label>ZIP Code</mat-label>
                      <input  type="text" matInput [attr.autocomplete]="false" placeholder="ZIP Code" id="zipcode" name="zipcode" formControlName="zipcode"
                             mask="99999" />
                      <mat-error *ngIf="ldpinfo.get('zipcode').hasError('required')">
                          ZIP Code is required.
                      </mat-error>
                  </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
    
            <div class="col-md-6">
              <div class="row">
                <div class="col-md-12">
                  <h4>Contact Information</h4>
                </div>
              </div>
    
              <div class="row">
                <div class="col-md-12">
                 
    
                  <div>
                    <mat-form-field appearance="outline">
                      <mat-label>First Name</mat-label>
                      <input required matInput autocomplete="off" placeholder="First Name" id="firstname" name="firstname" formControlName="firstname" maxlength="100" />
                      <mat-error *ngIf="ldpinfo.get('firstname').hasError('required')">
                        First Name is required.
                      </mat-error>
                    </mat-form-field>
                  </div>
    
                  <div>
                    <mat-form-field appearance="outline">
                      <mat-label>Last Name</mat-label>
                      <input required matInput autocomplete="off" placeholder="Last Name" id="lastname" name="lastname" formControlName="lastname" maxlength="100" />
                      <mat-error *ngIf="ldpinfo.get('lastname').hasError('required')">
                        Last Name is required.
                      </mat-error>
                    </mat-form-field>
                  </div>
    
                 <div>   <mat-form-field appearance="outline">
                  <mat-label>Email Address</mat-label>
                  <input matInput id="email" name="email" [attr.autocomplete]="false" formControlName="email" placeholder="Enter email address" type="text" required trim="blur">
                  <mat-error *ngIf="ldpinfo.get('email').touched && ldpinfo.get('email').errors && ldpinfo.get('email').errors?.required">
                      Email
                      Address is required
                  </mat-error>
                  <mat-error *ngIf="ldpinfo.get('email').touched && ldpinfo.get('email').errors && ldpinfo.get('email').errors?.pattern">
                      Invalid
                      Email Address
                  </mat-error>
                  <mat-error *ngIf="ldpinfo.get('email').touched && ldpinfo.get('email').errors && ldpinfo.get('email').errors?.maxlength">
                      You have
                      exceeded the maximum number of 100 characters.
                  </mat-error>
              </mat-form-field></div>
    
                  <div>
                    <mat-form-field appearance="outline">
                      <mat-label>Phone Number</mat-label>
                      <input required matInput id="telephone1" [attr.autocomplete]="false" formControlName="telephone1" type="tel" mask="(000) 000-0000" />
                      <mat-error *ngIf="ldpinfo.get('telephone1').hasError('required')">
                          Phone Number is required.
                      </mat-error>
                  </mat-form-field>
                  </div>       
                  <div style="margin-top: -15px;margin-bottom: 20px">
                  <mat-checkbox name="telephone1sms" formControlName="telephone1sms" id="isverified">
                    Receive important text alerts to your primary phone number.</mat-checkbox>
                </div>
    
          
    
                  <div>
                    <mat-form-field appearance="outline">
                      <mat-label>Website</mat-label>
                      <input
                        matInput
                        id="website"
                        autocomplete="off" 
                        formControlName="website"
                        placeholder="Website"
                        type="text">
                    </mat-form-field>
                  </div>
    
                  <div>
                    <mat-form-field appearance="outline">
                      <mat-label>How did you hear about us ?</mat-label>
                      <mat-select id="hearaboutus" name="hearaboutus" formControlName="hearaboutus" required="true">
                          <mat-option *ngFor="let item of hearaboutustypes" [value]="item.value">{{ item.label }}</mat-option>
                      </mat-select>
                      <mat-error *ngIf="ldpinfo.get('hearaboutus').hasError('required') ">
                        How did you hear about us ? is required.
                    </mat-error>
                  </mat-form-field>
                    
                 
                  </div>
                  <div *ngIf="(ldpinfo.value.hearaboutus == '700000006')">
                    <mat-form-field [hidden]="!(ldpinfo.value.hearaboutus == '700000006')" appearance="outline" style="width: 100%;">
                      <mat-label>Other</mat-label>
                      <textarea matInput [required]="ldpinfo.value.hearaboutus == '700000006'" placeholder="" id="hearaboutusOther" name="hearaboutusOther"
                                formControlName="hearaboutusOther" maxlength="2000" rows="5"></textarea>
                      <mat-error *ngIf="ldpinfo.get('hearaboutusOther').hasError('required') ">
                          Other is required.
                      </mat-error>
                  
                  </mat-form-field>
                  </div>
                  <div>
                    <mat-checkbox name="confirm1"
                                  formControlName="confirm1"
                                  id="confirm1"  (change)="oncheckboxChange($event)">
                                  <span *ngIf="!ischecked" style="color:#ad2c23"> *</span>  I acknowledge that I will be registered as a License Design Professional
                        for the Earthquake Brace + Bolt Program <span class="ess-content">and Earthquake Soft Story</span> License
                        Design Professional Directory.
                    </mat-checkbox>
                </div>
                </div>
              </div>
            </div>
            <div class="col-sm-12" style="margin-top: 1em;">
              <button mat-button mat-raised-button matStepperPrevious  style="float: left;">
                BACK
            </button>
              <button mat-button mat-raised-button [disabled]="ldpinfo.pristine || ldpinfo.invalid" style="float: right;" (click)="onSave(stepper) ">
                SUBMIT
            </button>
            </div>
            <div class="col-md-12" style="margin-top: 1em;" *ngIf="formAutoSave">
                <mat-progress-bar
                  mode="indeterminate"
                  style="width: 100%"></mat-progress-bar>
            </div>
            <div class="col-md-12" style="color: #ad2c23;" *ngIf="message">
              {{message}}
            </div>
          </div>
        </form>
      </div>
    </div>

  
  </mat-step>

  <mat-step>
    <ng-template matStepLabel>Done</ng-template>
    <h1>CONGRATULATIONS {{ ldpfullname }}</h1>
    <p>
      You have successfully registered as License Design Professional 
      for the Earthquake Brace + Bolt Program <span class="ess-content">and Earthquake Soft Story</span> Program
      License Design Professional Directory. Make sure our emails do not
      end up in your Spam or Junk Mail folders! Mark 
      info@crmp.org as safe in your email program.
    </p>

  </mat-step>
</mat-horizontal-stepper>
